<script>

import Textbox from '@/components/Textbox'
import Btn from '@/components/Btn'
import LoginRegisterSwitcher from '@/components/LoginRegisterSwitcher'
import { required } from 'vuelidate/lib/validators'
import router from '../router'

export default {
  name: 'login',
  components: {
    Textbox,
    Btn,
    LoginRegisterSwitcher
  },
  data () {
    return {
      login: '',
      password: '',
      loading: false,
      autofill: false,
      ga: false,
      ga_key: ''
    }
  },
  validations: {
    login: {
      required
    },
    password: {
      required
    },
    ga_key: {
      required
    }
  },
  computed: {
    className () {
      return this.$v.$error ? 'shake animated' : ''
    },
    buttonDisabled () {
      return false
    },
    privacyPolicyLink () {
      return this.$i18n.locale === 'en' ? 'http://s.platformcraft.ru/privacy_policy.pdf' : 'http://s.platformcraft.ru/privacy_policy_ru.pdf'
    }
  },
  methods: {
    signIn () {
      if (this.ga && this.$v.ga_key.$invalid) {
        this.$v.$touch()
        return
      }
      if (!this.ga) {
        this.$v.$reset()
        this.ga_key = ''
      }
      if (!this.$v.login.$invalid && !this.$v.password.$invalid) {
        return this.$api.login({
          username: this.login,
          password: this.password,
          ga: this.ga_key
        }).then(({ _, status }) => {
          if (status === 202) {
            this.ga = true
            return
          }
          this.afterLogin()
        }).catch(() => {
          this.$toast.show({
            text: this.ga ? this.$t('Неверный код.') : this.$t('Неверно введён логин или пароль.')
          })
        })
      } else {
        this.$v.$touch()
      }
    },
    backToLogin () {
      this.ga = false
    },
    afterLogin () {
      this.$api.loginV2({
        login: this.login,
        password: this.password
      }).then(({ data }) => {
        this.$api.setToken(data)
        window.location.href = '/home'
      }).catch(() => {
        window.location.href = '/home'
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.loading = true
      this.$api.confirmRegister({
        id: this.$route.params.id,
        domain: window.location.host
      }).then((response) => {
        this.loading = false
        this.$toast.show({
          text: this.$t('Аккаунт успешно активирован.')
        })
      }).catch((error) => {
        let text = 'Ошибка сервера.'
        if (error.response.status === 404) {
          this.login_busy = true
          text = 'Активация по указанной ссылке уже была произведена ранее.'
        }
        if (error.response.status === 403) {
          text = 'Регистрация запрещена.'
        }
        this.$toast.show({
          text: this.$t(text)
        })
        this.loading = false
      })
      router.push({ name: 'login' })
    }
    setTimeout(() => {
      this.autofill = !!this.$el.querySelector('[type="password"]:-webkit-autofill')
    }, 1000)
  },
  watch: {
    password (value) {
      if (!value) {
        this.autofill = false
      }
    }
  }
}

</script>

<template lang="pug">

.wrapper
  .login(:class="className")
    .form(@keyup.enter="signIn")
      template(v-if="ga")
        .row
          .col-xs-12
            .text-uppercase.text-big.center {{ $t('Авторизация Google') }}
        .margin-top-2x.margin-bottom-2x
          .inline-block.margin-bottom {{ $t('Google Authenticator код') }}
          textbox(v-model="ga_key", :validator="$v.ga_key")
          .has-error(v-if="$v.ga_key.$error") {{ $t('Введите код.') }}
        .row
          .col-xs-6.forgot.line-height-3x
            a.pointer.text-light.text-uppercase(style="color: #000", @click="backToLogin") {{ $t('назад') }}
          .col-xs-6.text-right
            btn(style="background: #000", @click="signIn", :disabled="buttonDisabled") {{ $t('Войти') }}
      template(v-else)
        .margin-bottom-2x
          .inline-block.margin-bottom.text-uppercase {{ $t('Логин') }}
          textbox(v-model="login", :validator="$v.login")
          .has-error(v-if="$v.login.$error") {{ $t('Введите логин.') }}
        .margin-bottom-2x
          .inline-block.margin-bottom.text-uppercase {{ $t('Пароль') }}
          textbox(v-model="password", type="password", :validator="$v.password")
          .has-error(v-if="$v.password.$error") {{ $t('Введите пароль.') }}
        .row
          .col-xs-6.forgot.line-height-3x
            router-link.text-light.text-uppercase(style="color: #000", :to="{ name: 'restore' }") {{ $t('Я забыл :(') }}
          .col-xs-6.text-right
            btn(style="background: #000", @click="signIn", :disabled="buttonDisabled") {{ $t('Войти') }}

</template>

<style scoped lang="sass">

.wrapper
  padding-top: 100px

.login
  width: 350px
  margin: auto
  background: #FFFFFF
  +clearfix

.center
  text-align: center

.pointer
  cursor: pointer

.form
  padding: 25px 20px

</style>
